// extracted by mini-css-extract-plugin
module.exports = {"slickCurrent":"YogaSandhyaBrownGallery_slickCurrent__xNwLX","slickDeactive":"YogaSandhyaBrownGallery_slickDeactive__k_Kqk"};